import { TransportAxle, TransportPriceList, TransportSurchargeType, TransportVehicleClass, TransportVolumeCategory } from "../../../system/Domain";

export const axleLabels: Record<TransportAxle, string> = {
	Own: "Eigenachse",
	Foreign: "Fremdachse"
};

export const vehicleClassLabels: Record<TransportVehicleClass, string> = {
	Pkw: "PKW",
	Suv: "SUV",
	LcvSmall: "LCV klein"
};

export const volumeCategoryLabels: Record<TransportVolumeCategory, string> = {
	S: "S",
	M: "M",
	L: "L",
	XL: "XL"
};

export const surchargeLabels: Record<TransportSurchargeType, string> = {
	ShortTermPlate: "Kurzzeitkennzeichen",
	MissedTransport: "Fehlfahrt",
	Other: "Sonstiges"
};

export const maximumNumberOfVehicles = 8;

export type ListStatus = "planned" | "active" | "expired";

const dateOnly = (value: string) => value.substring(0, 10);

/** Compares calendar dates as text (yyyy-MM-dd), so no time zone shifts are involved. */
export const getListStatus = (list: Pick<TransportPriceList, "validFrom" | "validTo">, today: string): ListStatus => {
	if (dateOnly(list.validFrom) > today) {
		return "planned";
	}

	return list.validTo && dateOnly(list.validTo) < today ? "expired" : "active";
};

export const statusLabels: Record<ListStatus, string> = {
	planned: "Geplant",
	active: "Gültig",
	expired: "Abgelaufen"
};
